import React from 'react';
import { Box, Typography, Button } from '@mui/material';

export default function EmptyState({ title='No data', description='There is nothing to show yet.', actionLabel, onAction }){
  return (
    <Box sx={{ textAlign:'center', py:6, px:2, color:'text.secondary' }}>
      <Typography variant="h6" sx={{ mb:1 }}>{title}</Typography>
      <Typography variant="body2" sx={{ mb:2 }}>{description}</Typography>
      {actionLabel && onAction && (
        <Button variant="contained" size="small" onClick={onAction}>{actionLabel}</Button>
      )}
    </Box>
  );
}

